import React, { Component } from 'react';
import {
  TableCell,
  TableHead,
  TableRow,
} from '@material-ui/core';
import PropTypes from 'prop-types';

class EcommTableHeader extends Component {
  render() {
    const {
      headerKey,
      tableTitle
    } = this.props;

    return (
      <TableHead>
        <TableRow>
          <TableCell key={headerKey}>
            <h1>{tableTitle}</h1>
          </TableCell>
        </TableRow>
      </TableHead>
    )
  }
}

EcommTableHeader.propTypes = {
  headerKey: PropTypes.string.isRequired,
  tableTitle: PropTypes.string.isRequired,
};

export default EcommTableHeader;
